import { useEffect, useState } from "react";
import { Card, Container, Spinner, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";

//interfaces
import { SucursalInterface } from "../../../../interfaces/SucursalInterface";

//estilos
const classes = require("./SucursalDetalle.module.css").default;

/**
 * SucursalDetalle
 * @description: Componente que muestra el detalle de una sucursal.
 * @date [fecha actual]
 * @param Props Ninguno
 * @returns JSX del detalle de la sucursal.
 */

const SucursalDetalle = () => {
  const { idSucursal } = useParams();
  const { sendRequest } = useFetch();
  const [sucursal, setSucursal] = useState<SucursalInterface>();

  //Función que trata el detalle de sucursal.
  const transformData = (variable: any) => {
    setSucursal(variable.data);
  };

  useEffect(() => {
    sendRequest(
      {
        url: `/sucursal/${idSucursal}`,
      },
      transformData
    );
  }, [idSucursal, sendRequest]);

  //mientras se carga el detalle se muestra un spinner
  if (!sucursal) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container style={{ marginTop: "20px" }}>
      <h2>Detalle de la sucursal {idSucursal}</h2>
      <Card>
        <Card.Header>
          <h4>{sucursal.nombre}</h4>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <p><strong>ID:</strong> {sucursal.id}</p>
              <p><strong>ID de Sucursal:</strong> {(sucursal as any).id_nmp || "No asignado"}</p>
              <p><strong>Nombre:</strong> {sucursal.nombre}</p>
              <p><strong>Domicilio:</strong> {sucursal.domicilio}</p>
              <p><strong>Estado:</strong> {sucursal.estado.nombre}</p>
              {(sucursal as any).plataforma_id === 2 && (
                <div>
                  <strong>Correos para orden de servicio:</strong>
                  {sucursal.correo ? (
                    <ul className="mb-0 mt-1">
                      {sucursal.correo.split(",").map((c, i) => (
                        <li key={i}>{c.trim()}</li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-muted mb-0"> No asignado</p>
                  )}
                </div>
              )}
            </Col>
            <Col md={6}>
              <p><strong>Latitud:</strong> {sucursal.latitud}</p>
              <p><strong>Longitud:</strong> {sucursal.longitud}</p>
              <div className="mt-3">
                <h6>Ubicación en el mapa:</h6>
                <a 
                  href={`https://www.google.com/maps?q=${sucursal.latitud},${sucursal.longitud}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-primary btn-sm"
                >
                  Ver en Google Maps
                </a>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default SucursalDetalle;
